import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PublicNavbar() {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="border-b border-gray-200 bg-white sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <button
            onClick={() => navigate('/')}
            className="text-2xl font-bold text-blue-600 cursor-pointer hover:text-blue-700 flex-shrink-0"
          >
            Snaptura
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            <a
              href="/#features"
              className="text-gray-600 hover:text-gray-900"
            >
              Features
            </a>
            <button
              onClick={() => navigate('/pricing')}
              className="text-gray-600 hover:text-gray-900"
            >
              Pricing
            </button>
            <button
              onClick={() => navigate('/docs')}
              className="text-gray-600 hover:text-gray-900"
            >
              Docs
            </button>
            <button
              onClick={() => navigate('/support')}
              className="text-gray-600 hover:text-gray-900"
            >
              Support
            </button>
            <button
              onClick={() => navigate('/login')}
              className="text-gray-600 hover:text-gray-900"
            >
              Log In
            </button>
            <button
              onClick={() => navigate('/register')}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Start Free
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100"
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {mobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-3">
              <a
                href="/#features"
                className="text-gray-600 hover:text-gray-900 px-4 py-2 rounded-lg hover:bg-gray-50"
                onClick={() => setMobileMenuOpen(false)}
              >
                Features
              </a>
              <button
                onClick={() => {
                  navigate('/pricing');
                  setMobileMenuOpen(false);
                }}
                className="text-left text-gray-600 hover:text-gray-900 px-4 py-2 rounded-lg hover:bg-gray-50"
              >
                Pricing
              </button>
              <button
                onClick={() => {
                  navigate('/docs');
                  setMobileMenuOpen(false);
                }}
                className="text-left text-gray-600 hover:text-gray-900 px-4 py-2 rounded-lg hover:bg-gray-50"
              >
                Docs
              </button>
              <button
                onClick={() => {
                  navigate('/support');
                  setMobileMenuOpen(false);
                }}
                className="text-left text-gray-600 hover:text-gray-900 px-4 py-2 rounded-lg hover:bg-gray-50"
              >
                Support
              </button>
              <button
                onClick={() => {
                  navigate('/login');
                  setMobileMenuOpen(false);
                }}
                className="text-left text-gray-600 hover:text-gray-900 px-4 py-2 rounded-lg hover:bg-gray-50"
              >
                Log In
              </button>
              <button
                onClick={() => {
                  navigate('/register');
                  setMobileMenuOpen(false);
                }}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors text-center"
              >
                Start Free
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
